import axios from 'axios';
import { SimpleMultiSelectOption } from '../../../common/components/input/multiSelectStyled';

const baseUrl = process.env.REACT_APP_QCX_API_BASE_URL + '/fatura';

const exportFatura = async (
  followupIds: number[] | null,
  clientes: string[],
  token: string,
  unidadeId: number,
  numerosLegacy?: string[] | null
) => {
  let message: string | null = null;
  const params = new URLSearchParams();

  if (followupIds && followupIds.length > 0) {
    followupIds.forEach((id) => params.append('followupIds', String(id)));
  } else if (numerosLegacy && numerosLegacy.length > 0) {
    numerosLegacy.forEach((n) => params.append('numeros', n));
  } else {
    return 'Selecione ao menos um FollowUp.';
  }

  if (clientes && clientes.length > 0) {
    clientes.forEach((c) => params.append('clientes', c));
  }

  try {
    const response = await axios.get(`${baseUrl}/export-fatura?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        quickcomexTenant: unidadeId,
      },
      responseType: 'blob',
    });

    if (response.status === 200) {
      const file = new File([response.data], 'exportFaturaOcr.xlsx', {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name;
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      message = await (response.data as any).text?.();
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response?.data) {
        try {
          message = await (error.response.data as any).text?.();
        } catch {
          message = 'Erro inesperado';
        }
      } else {
        message = 'Erro inesperado';
      }
    } else {
      message = 'Erro inesperado';
    }
  }
  return message;
};

const fetchFollowUpsPorClientes = async (
  clientes: string[],
  token: string,
  unidadeId: number
): Promise<SimpleMultiSelectOption[]> => {
  if (!clientes?.length) return [];
  const params = new URLSearchParams();
  clientes.forEach((c) => params.append('clientes', c));

  const resp = await axios.get(`${baseUrl}/buscar-followups-por-clientes?${params.toString()}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      quickcomexTenant: unidadeId,
    },
  });

  if (resp.status === 200 && Array.isArray(resp.data)) {
    // esperado: [{ id, numero, cliente }]
    return resp.data.map((row: any) => ({
      id: row.id,
      value: String(row.numero),      // usaremos ID do followup
      label: String(row.numero),  // número visível no multiselect
    }));
  }
  return [];
};

const fetchClientsNome = async (
  inputValue: string,
  token: string,
  unidadeId: number
): Promise<SimpleMultiSelectOption[]> => {
  let clientOptions: SimpleMultiSelectOption[] = [];
  const params = new URLSearchParams();
  params.set('nome', inputValue);

  try {
    const response = await axios.get(`${baseUrl}/buscar-clientes?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        quickcomexTenant: unidadeId,
      },
    });

    if (response.status === 200 && Array.isArray(response.data)) {
      clientOptions = response.data.map((client: any) => ({
        id: client,     // id único (usa o nome)
        value: client,  // valor enviado ao backend
        label: client,  // rótulo exibido
      }));
    }
  } catch (error) {
    console.error('Erro ao buscar os nomes dos clientes:', error);
  }

  return clientOptions;
};

export { exportFatura, fetchFollowUpsPorClientes, fetchClientsNome };
